import { dureeLisible } from './datesDeLAgenda';
import { largeurDeLaJauge } from './journeeEnCours';

/**
 * Le temps pris par la journée qu'on compose, à l'ordinateur et au téléphone (chantier
 * `nettoyage-journee`, ticket 02) : « 1 h 30 sur 2 h », et la jauge qui se remplit. Chaque écran
 * pose les mots dans sa propre boîte.
 */

/** « <b>1 h 30</b> sur 2 h ». */
export function TempsPris({ utilise, tempsMin }: { utilise: number; tempsMin: number }) {
  return (
    <>
      <b>{dureeLisible(utilise)}</b> sur {dureeLisible(tempsMin)}
    </>
  );
}

/** La jauge du temps pris, pleine au plus. */
export function JaugeDuJour({ utilise, tempsMin }: { utilise: number; tempsMin: number }) {
  return (
    <div className="preparer-jauge" aria-hidden="true">
      <i style={{ width: largeurDeLaJauge(utilise, tempsMin) }} />
    </div>
  );
}
